import axios from 'axios';
/* global newrelic */

import eventDetails from './eventDetails';
import underlyingList from './underlyingList';

const getEventDetails = async () => eventDetails;

const generateProductHref = (p) => {
  let type;
  switch (p.type) {
    case 'Commodity ETCs':
      type = 'commodities';
      break;
    case 'Equity ETCs':
      type = 'equities';
      break;
    case 'Fixed Income ETCs':
      type = 'fixed-income';
      break;
    default:
      type = 'currencies';
      break;
  }

  let prefix = 'products/short-leveraged-etps';
  if (
    p.name.toLowerCase().indexOf('boost') >= 0
    || (p.fundTypeID && p.fundTypeID === '35') // boost fun type id. ungly workaround
  ) {
    prefix = 'etps';
  }
  return `https://www.wisdomtree.eu/${prefix}/${type}/${p.name
    .toLowerCase()
    .replace(/\s/g, '-')
    .replace('s&p', 'sp')
    .replace('®', '')}`;
};

const dateQuery = (dt) => `${dt.getFullYear()}-${dt.getMonth() + 1}-${dt.getDate()}`;
const getCalendarEvents = async (params) => {
  const date = new Date();
  let monthOffset = 0;
  if (params.range === 'nextMonth') {
    monthOffset = 1;
  } else if (params.range === 'prevMonth') {
    monthOffset = -1;
  }
  const firstDay = new Date(date.getFullYear(), date.getMonth() + monthOffset, 1);
  const lastDay = new Date(date.getFullYear(), date.getMonth() + monthOffset + 1, 0);
  return axios
    .get(`${process.env.REACT_APP_DATASPAN_API_URL}/slcalendar/events/`, {
      params: {
        start: dateQuery(firstDay),
        end: dateQuery(lastDay),
        // filters: params.filters,
        country: ((window.slHeatmap && window.slHeatmap.isoCode) || 'en-GB').split('-')[1],
      },
    })
    .then((response) => {
      const events = [];
      response.data.forEach((e) => {
        if (e.enum.parent) {
          const eventDt = e.dt;
          // find parent in events
          const parent = events.find((x) => x.name === e.enum.parent.name && x.dt === eventDt);
          if (parent) {
            parent.children.push(e);
          } else {
            events.push({
              ...e.enum.parent,
              isParent: true,
              dt: eventDt,
              children: [e],
              releaseTime: e.enum.releaseTime,
            });
          }
        } else {
          events.push(e);
        }
      });
      return events.sort((a, b) => new Date(a.dt) - new Date(b.dt));
    })
    .catch((error) => {
      console.error(error);
      newrelic.noticeError(error);
    });
};

/**
 *
 * @param {
 *  email,
 *  investorType,
 * } params
 */
const createAlertMe = (params) => {
  axios
    .post(`${process.env.REACT_APP_DATASPAN_API_URL}/slcalendar/alert/`, {
      email: params.email,
      investorType: params.investorType,
      eventId: params.event.id,
      eventName: params.event.displayName || params.event.name,
      dt: params.event.dt,
    })
    .then(() => {
      // console.log(response);
    })
    .catch((error) => {
      console.log(error);
    });
};

const API = {
  // getCalendarEvents,
  getEventDetails,
  getCalendarEvents,
  createAlertMe,

  getProductsFromUnderlyingsArr: (underlyingsArr) =>
    axios
      .get(`${process.env.REACT_APP_DATASPAN_API_URL}/products/`, {
        params: {
          category: underlyingsArr.join(','),
          country: ((window.slHeatmap && window.slHeatmap.isoCode) || 'en-GB').split('-')[1],
        },
      })
      .then((response) =>
        // console.log('result: ', response);
        response.data
          .map((p) => ({
            ...p,
            href: generateProductHref(p),
          }))
          .reduce((arr, b) => {
            if (arr.find((x) => x.name === b.name)) return arr;
            arr.push(b);
            return arr;
          }, []),)
      .catch((error) => {
        console.error(error);
        newrelic.noticeError(error);
      }),
  // use static underlying list to map live change tickers (move this static list to server side at some point)
  getChangeForUnderlyingsArr: (underlyingArr) => {
    // create underlying + respective ticker array
    const utArr = underlyingArr
      .map((u) => ({
        ticker: (underlyingList.find((x) => x.name === u) || {}).ticker,
        underlying: u,
      }))
      .filter((x) => x.ticker !== undefined);
    // console.log('tickers', utArr);
    // return ChangeForUnderlyingsArr;
    return axios
      .get(`${process.env.REACT_APP_DATASPAN_API_URL}/tickers/live/`, {
        params: {
          t: utArr.map((ut) => ut.ticker).join(','),
        },
      })
      .then((response) => {
        const { data: responseData } = response;
        // console.log('response responseData: ', responseData);
        // aux.data.chg.toFixed(2)
        responseData.forEach((aux) => {
          const ut = utArr.find((x) => x.ticker === aux.ticker);
          if (ut) {
            ut.chg = aux.data.chg.toFixed(2);
          }
        });

        return utArr;
      })
      .catch((error) => {
        console.error('axios.catch: ', error);
        newrelic.noticeError(error);
        return null;
      });
  }, // end getChangeForUnderlyingsArr
};

export default API;
